function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgHospital = function SvgHospital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#D1EFF2"
    },
    d: "M493.131,332.507H389.506v165.16h113.132c5.171,0,9.363-4.192,9.363-9.363V351.375 C512,340.954,503.552,332.507,493.131,332.507z"
  }), React.createElement("path", {
    style: {
      fill: "#BDC0C3"
    },
    d: "M389.506,457.191v40.476h113.132c5.171,0,9.363-4.192,9.363-9.363v-31.113H389.506z"
  }), React.createElement("rect", {
    x: 389.51,
    y: 449.69,
    style: {
      fill: "#76B7EB"
    },
    width: 122.49,
    height: 15
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M468.899,412.673h-36.292c-5.06,0-9.162-4.102-9.162-9.162v-26.39c0-5.06,4.102-9.163,9.162-9.163 h36.292c5.06,0,9.163,4.102,9.163,9.163v26.39C478.061,408.57,473.959,412.673,468.899,412.673z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.899,420.172h-36.292c-9.188,0-16.663-7.475-16.663-16.662v-26.39 c0-9.188,7.475-16.663,16.663-16.663h36.292c9.188,0,16.662,7.475,16.662,16.663v26.39 C485.561,412.698,478.086,420.172,468.899,420.172z M432.607,375.458c-0.917,0-1.663,0.746-1.663,1.663v26.39 c0,0.917,0.746,1.662,1.663,1.662h36.292c0.916,0,1.662-0.746,1.662-1.662v-26.39c0-0.917-0.746-1.663-1.662-1.663L432.607,375.458 L432.607,375.458z"
  }), React.createElement("path", {
    style: {
      fill: "#D1EFF2"
    },
    d: "M18.869,332.507h103.626v165.16H9.363c-5.171,0-9.363-4.192-9.363-9.363V351.375 C0,340.954,8.448,332.507,18.869,332.507z"
  }), React.createElement("path", {
    style: {
      fill: "#BDC0C3"
    },
    d: "M122.494,457.191v40.476H9.363c-5.171,0-9.363-4.192-9.363-9.363v-31.113H122.494z"
  }), React.createElement("rect", {
    y: 449.69,
    style: {
      fill: "#76B7EB"
    },
    width: 122.49,
    height: 15
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M43.101,412.673h36.292c5.06,0,9.162-4.102,9.162-9.162v-26.39c0-5.06-4.102-9.163-9.162-9.163 H43.101c-5.06,0-9.163,4.102-9.163,9.163v26.39C33.939,408.57,38.041,412.673,43.101,412.673z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M79.393,420.172H43.101c-9.188,0-16.662-7.475-16.662-16.662v-26.39 c0-9.188,7.475-16.663,16.662-16.663h36.292c9.188,0,16.663,7.475,16.663,16.663v26.39 C96.056,412.698,88.581,420.172,79.393,420.172z M43.101,375.458c-0.917,0-1.662,0.746-1.662,1.663v26.39 c0,0.917,0.746,1.662,1.662,1.662h36.292c0.917,0,1.663-0.746,1.663-1.662v-26.39c0-0.917-0.746-1.663-1.663-1.663L43.101,375.458 L43.101,375.458z"
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M18.869,332.507C8.448,332.507,0,340.954,0,351.375v136.928 c0,5.171,4.192,9.363,9.363,9.363H61.09c-29.397-27.154-29.456-127.599-29.292-165.16H18.869V332.507z"
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M411.471,332.507h-21.966v165.16h72.62 C423.449,468.615,412.895,368.827,411.471,332.507z"
  }), React.createElement("rect", {
    x: 122.49,
    y: 143.26,
    style: {
      fill: "#D1EFF2"
    },
    width: 267.01,
    height: 354.4
  }), React.createElement("polygon", {
    style: {
      fill: "#BDC0C3"
    },
    points: "122.494,457.191 122.494,497.666 122.494,497.666 389.506,497.666 389.506,457.191 "
  }), React.createElement("g", null, React.createElement("rect", {
    x: 122.49,
    y: 449.69,
    style: {
      fill: "#76B7EB"
    },
    width: 267.01,
    height: 15
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M401.279,78.799H110.72c-5.629,0-10.192,4.563-10.192,10.192v44.082 c0,5.629,4.563,10.192,10.192,10.192h290.559c5.629,0,10.192-4.563,10.192-10.192V88.991 C411.471,83.362,406.908,78.799,401.279,78.799z"
  })), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M179.465,78.799v16.559c0,9.653,7.853,17.507,17.507,17.507h24.963v24.963 c0,1.899,0.313,3.723,0.875,5.437h66.379c0.562-1.714,0.875-3.538,0.875-5.437v-24.963h24.964c9.653,0,17.507-7.853,17.507-17.507 V78.799H179.465z"
  }), React.createElement("path", {
    style: {
      fill: "#38648C"
    },
    d: "M277.995,52.489V19.77c0-3.003-2.434-5.437-5.437-5.437h-33.117c-3.003,0-5.437,2.434-5.437,5.437 v32.718c0,2.383-1.932,4.315-4.315,4.315h-32.718c-3.003,0-5.437,2.434-5.437,5.437v33.117c0,3.003,2.434,5.437,5.437,5.437h32.718 c2.383,0,4.315,1.932,4.315,4.315v32.718c0,3.003,2.434,5.437,5.437,5.437h33.117c3.003,0,5.437-2.434,5.437-5.437v-32.718 c0-2.383,1.932-4.315,4.315-4.315h32.718c3.003,0,5.437-2.434,5.437-5.437V62.24c0-3.003-2.434-5.437-5.437-5.437H282.31 C279.927,56.804,277.995,54.872,277.995,52.489z"
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M304.3,412.673h-96.6c-8.928,0-16.166,7.238-16.166,16.166v68.828h128.931v-68.828 C320.465,419.91,313.228,412.673,304.3,412.673z"
  }), React.createElement("rect", {
    x: 248.5,
    y: 412.671,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 15,
    height: 84.994
  }), React.createElement("g", null, React.createElement("ellipse", {
    style: {
      fill: "#F28B74"
    },
    cx: 187.03,
    cy: 214.41,
    rx: 25.449,
    ry: 20.267
  }), React.createElement("ellipse", {
    style: {
      fill: "#F28B74"
    },
    cx: 324.97,
    cy: 214.41,
    rx: 25.449,
    ry: 20.267
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M201.86,201.688c-4.142,0-7.5-3.358-7.5-7.5v-8.987c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5 v8.987C209.36,198.33,206.002,201.688,201.86,201.688z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M310.14,201.688c-4.142,0-7.5-3.358-7.5-7.5v-8.987c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5 v8.987C317.64,198.33,314.282,201.688,310.14,201.688z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M256,208.589c-7.639,0-14.902-3.308-19.928-9.076c-2.721-3.123-2.396-7.86,0.727-10.582 c3.123-2.721,7.86-2.396,10.582,0.727c2.177,2.497,5.318,3.93,8.62,3.93c3.301,0,6.443-1.433,8.62-3.93 c2.721-3.124,7.459-3.448,10.582-0.727s3.448,7.458,0.727,10.582C270.902,205.281,263.639,208.589,256,208.589z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M341.337,294.651h-57.365c-5.017,0-9.084-4.067-9.084-9.084v-21.025 c0-5.017,4.067-9.084,9.084-9.084h57.365c5.017,0,9.084,4.067,9.084,9.084v21.025C350.421,290.585,346.354,294.651,341.337,294.651 z"
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M228.028,294.651h-57.365c-5.017,0-9.084-4.067-9.084-9.084v-21.025 c0-5.017,4.067-9.084,9.084-9.084h57.365c5.017,0,9.084,4.067,9.084,9.084v21.025C237.112,290.585,233.045,294.651,228.028,294.651 z"
  })), React.createElement("rect", {
    x: 305.15,
    y: 255.46,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 15,
    height: 39.19
  }), React.createElement("rect", {
    x: 191.84,
    y: 255.46,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 15,
    height: 39.19
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.337,302.151h-57.365c-9.144,0-16.583-7.439-16.583-16.584v-21.025 c0-9.144,7.439-16.584,16.583-16.584h57.365c9.145,0,16.584,7.439,16.584,16.584v21.025 C357.921,294.712,350.482,302.151,341.337,302.151z M283.972,262.958c-0.873,0-1.583,0.71-1.583,1.584v21.025 c0,0.874,0.71,1.584,1.583,1.584h57.365c0.874,0,1.584-0.71,1.584-1.584v-21.025c0-0.873-0.711-1.584-1.584-1.584H283.972z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.028,302.151h-57.365c-9.145,0-16.584-7.439-16.584-16.584v-21.025 c0-9.144,7.439-16.584,16.584-16.584h57.365c9.144,0,16.583,7.439,16.583,16.584v21.025 C244.611,294.712,237.172,302.151,228.028,302.151z M170.663,262.958c-0.874,0-1.584,0.71-1.584,1.584v21.025 c0,0.874,0.71,1.584,1.584,1.584h57.365c0.873,0,1.583-0.71,1.583-1.584v-21.025c0-0.873-0.71-1.584-1.583-1.584H170.663z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M341.337,373.258h-57.365c-5.017,0-9.084-4.067-9.084-9.084V343.15c0-5.017,4.067-9.084,9.084-9.084 h57.365c5.017,0,9.084,4.067,9.084,9.084v21.025C350.421,369.191,346.354,373.258,341.337,373.258z"
  }), React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M228.028,373.258h-57.365c-5.017,0-9.084-4.067-9.084-9.084V343.15c0-5.017,4.067-9.084,9.084-9.084 h57.365c5.017,0,9.084,4.067,9.084,9.084v21.025C237.112,369.191,233.045,373.258,228.028,373.258z"
  })), React.createElement("rect", {
    x: 305.15,
    y: 334.06,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 15,
    height: 39.19
  }), React.createElement("rect", {
    x: 191.84,
    y: 334.06,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 15,
    height: 39.19
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.337,380.758h-57.365c-9.144,0-16.583-7.439-16.583-16.583V343.15 c0-9.145,7.439-16.584,16.583-16.584h57.365c9.145,0,16.584,7.44,16.584,16.584v21.025 C357.921,373.319,350.482,380.758,341.337,380.758z M283.972,341.565c-0.873,0-1.583,0.711-1.583,1.584v21.025 c0,0.873,0.71,1.583,1.583,1.583h57.365c0.874,0,1.584-0.71,1.584-1.583V343.15c0-0.874-0.711-1.584-1.584-1.584H283.972z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.028,380.758h-57.365c-9.145,0-16.584-7.439-16.584-16.583V343.15 c0-9.145,7.439-16.584,16.584-16.584h57.365c9.144,0,16.583,7.44,16.583,16.584v21.025 C244.611,373.319,237.172,380.758,228.028,380.758z M170.663,341.565c-0.874,0-1.584,0.711-1.584,1.584v21.025 c0,0.873,0.71,1.583,1.584,1.583h57.365c0.873,0,1.583-0.71,1.583-1.583V343.15c0-0.874-0.71-1.584-1.583-1.584H170.663z"
  })), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M122.494,497.666h122.984c-64.279-49.601-71.281-155.908-71.604-321.256 c-0.015-7.459,6.033-13.515,13.492-13.515h202.14v-19.631H122.494V497.666z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHospital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hospital.64d72b5d.svg";
export { ForwardRef as ReactComponent };